import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/administration/users/$userId/edit")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/workspace/users/$userId/edit",
      params: { userId: params.userId },
    });
  },
});
